interface RiskBadgeProps {
  level: string;
  text?: string;
  size?: "sm" | "md";
}

const RISK_MAP: Record<string, { label: string; className: string; dot: string }> = {
  high: {
    label: "高危",
    className: "bg-accent-500 text-background-50 border-accent-500",
    dot: "bg-background-50",
  },
  mid: {
    label: "中危",
    className: "bg-primary-500 text-background-50 border-primary-500",
    dot: "bg-background-50",
  },
  watch: {
    label: "观察",
    className: "bg-secondary-100 text-secondary-900 border-secondary-300",
    dot: "bg-secondary-600",
  },
};

export default function RiskBadge({ level, text, size = "sm" }: RiskBadgeProps) {
  const config = RISK_MAP[level] || RISK_MAP.watch;
  const sizeClass = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm";

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-label font-medium whitespace-nowrap ${config.className} ${sizeClass}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {text || config.label}
    </span>
  );
}